
<button mat-button class="primary">Basic</button>
<h1>Mercalink color theme</h1>
<div style="display: flex; justify-content: space-around;">
  @for (color of colors_theme; track color) {
    <!-- <button mat-raised-button [style.backgroundColor]="color" >{{ color }}</button> -->
    <div [class]="color" style="display: flex; flex-direction: column;">
    <button mat-flat-button   [class]="color"  (click)="openSnackBar(color)" style="margin:10px" >{{ color }}</button>
    <br>
      <section>
          <div class="example-button-row">
            <button mat-button>Basic</button>
            <button mat-button disabled>Disabled</button>
            <a mat-button href="https://www.google.com/" target="_blank">Link</a>
          </div>
        </section>
         <!-- <mat-divider></mat-divider> -->
        <section>
          <div class="example-button-row">
            <button mat-raised-button>Basic</button>
            <button mat-raised-button disabled>Disabled</button>
            <a mat-raised-button href="https://www.google.com/" target="_blank">Link</a>
          </div>
        </section>
         <!-- <mat-divider></mat-divider> -->
        <section>
          <div class="example-button-row">
            <button mat-stroked-button>Basic</button>
            <button mat-stroked-button disabled>Disabled</button>
            <a mat-stroked-button href="https://www.google.com/" target="_blank">Link</a>
          </div>
        </section>
         <!-- <mat-divider></mat-divider> -->
        <section>
          <div class="example-button-row">
            <button mat-flat-button>Basic</button>
            <button mat-flat-button disabled>Disabled</button>
            <a mat-flat-button href="https://www.google.com/" target="_blank">Link</a>
          </div>
        </section>
         <!-- <mat-divider></mat-divider> -->
        <section>
          <div class="example-button-row">
            <div class="example-flex-container">
              <button mat-icon-button aria-label="Example icon button with a vertical three dot icon">
                <mat-icon>more_vert</mat-icon>
              </button>
              <button mat-icon-button disabled aria-label="Example icon button with a open in new tab icon">
                <mat-icon>open_in_new</mat-icon>
              </button>
            </div>
          </div>
        </section>
         <!-- <mat-divider></mat-divider> -->
        <section>
          <div class="example-button-row">
            <div class="example-flex-container">
              <div class="example-button-container">
                <button mat-fab aria-label="Example icon button with a delete icon">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
              <div class="example-button-container">
                <button mat-fab disabled aria-label="Example icon button with a heart icon">
                  <mat-icon>favorite</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </section>
         <!-- <mat-divider></mat-divider> -->
        <section>
          <div class="example-button-row">
            <div class="example-flex-container">
              <div class="example-button-container">
                <button mat-mini-fab aria-label="Example icon button with a menu icon">
                  <mat-icon>menu</mat-icon>
                </button>
              </div>
              <div class="example-button-container">
                <button mat-mini-fab disabled aria-label="Example icon button with a home icon">
                  <mat-icon>home</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div class="example-button-row">
            <div class="example-flex-container">
              <div class="example-button-container">
                <button mat-fab extended>
                  <mat-icon>favorite</mat-icon>
                  Basic
                </button>
              </div>
              <div class="example-button-container">
                <button mat-fab extended disabled>
                  <mat-icon>favorite</mat-icon>
                  Disabled
                </button>
              </div>
              <div class="example-button-container">
                <a mat-fab extended routerLink=".">
                  <mat-icon>favorite</mat-icon>
                  Link
                </a>
              </div>
            </div>
          </div>
        </section>
  </div>

    } @empty {
    <li>There are no items.</li>
  }
</div>

<br><br><br><br><br><br><br><br><br><br><br><br>

<h1>Native angular color</h1>
<div style="display: flex; justify-content: space-around;">
  @for (color of colors_angular; track color) {
    <!-- <button mat-raised-button [style.backgroundColor]="color" >{{ color }}</button> -->
    <div [class]="color" style="display: flex; flex-direction: column;">
    <button mat-flat-button   [class]="color"  (click)="openSnackBar(color)" style="margin:10px" >{{ color }}</button>
    <br>
      <section>
          <div class="example-button-row">
            <button mat-button>Basic</button>
            <button mat-button disabled>Disabled</button>
            <a mat-button href="https://www.google.com/" target="_blank">Link</a>
          </div>
        </section>
         <!-- <mat-divider></mat-divider> -->
        <section>
          <div class="example-button-row">
            <button mat-raised-button>Basic</button>
            <button mat-raised-button disabled>Disabled</button>
            <a mat-raised-button href="https://www.google.com/" target="_blank">Link</a>
          </div>
        </section>
         <!-- <mat-divider></mat-divider> -->
        <section>
          <div class="example-button-row">
            <button mat-stroked-button>Basic</button>
            <button mat-stroked-button disabled>Disabled</button>
            <a mat-stroked-button href="https://www.google.com/" target="_blank">Link</a>
          </div>
        </section>
         <!-- <mat-divider></mat-divider> -->
        <section>
          <div class="example-button-row">
            <button mat-flat-button>Basic</button>
            <button mat-flat-button disabled>Disabled</button>
            <a mat-flat-button href="https://www.google.com/" target="_blank">Link</a>
          </div>
        </section>
         <!-- <mat-divider></mat-divider> -->
        <section>
          <div class="example-button-row">
            <div class="example-flex-container">
              <button mat-icon-button aria-label="Example icon button with a vertical three dot icon">
                <mat-icon>more_vert</mat-icon>
              </button>
              <button mat-icon-button disabled aria-label="Example icon button with a open in new tab icon">
                <mat-icon>open_in_new</mat-icon>
              </button>
            </div>
          </div>
        </section>
         <!-- <mat-divider></mat-divider> -->
        <section>
          <div class="example-button-row">
            <div class="example-flex-container">
              <div class="example-button-container">
                <button mat-fab aria-label="Example icon button with a delete icon">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
              <div class="example-button-container">
                <button mat-fab disabled aria-label="Example icon button with a heart icon">
                  <mat-icon>favorite</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </section>
         <!-- <mat-divider></mat-divider> -->
        <section>
          <div class="example-button-row">
            <div class="example-flex-container">
              <div class="example-button-container">
                <button mat-mini-fab aria-label="Example icon button with a menu icon">
                  <mat-icon>menu</mat-icon>
                </button>
              </div>
              <div class="example-button-container">
                <button mat-mini-fab disabled aria-label="Example icon button with a home icon">
                  <mat-icon>home</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div class="example-button-row">
            <div class="example-flex-container">
              <div class="example-button-container">
                <button mat-fab extended>
                  <mat-icon>favorite</mat-icon>
                  Basic
                </button>
              </div>
              <div class="example-button-container">
                <button mat-fab extended disabled>
                  <mat-icon>favorite</mat-icon>
                  Disabled
                </button>
              </div>
              <div class="example-button-container">
                <a mat-fab extended routerLink=".">
                  <mat-icon>favorite</mat-icon>
                  Link
                </a>
              </div>
            </div>
          </div>
        </section>
  </div>

    } @empty {
    <li>There are no items.</li>
  }
</div>

